export default function FlagRibbon({ className = "" }) {
  return (
    <div
      className={`flex h-1.5 w-full ${className}`}
      role="presentation"
      aria-hidden="true"
      data-testid="flag-ribbon"
    >
      <span className="flex-1" style={{ backgroundColor: "#D91023" }} />
      <span className="flex-1 bg-white" />
      <span className="flex-1" style={{ backgroundColor: "#D91023" }} />
    </div>
  );
}
